import { render } from "./Profile.vue?vue&type=template&id=06de4ae0&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=06de4ae0&scoped=true&lang=css"
import "./Profile.vue?vue&type=style&index=1&id=06de4ae0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06de4ae0"]])

export default __exports__